import { render, staticRenderFns } from "./ModalEliminarDocumento.vue?vue&type=template&id=4ade0751&scoped=true"
import script from "./ModalEliminarDocumento.vue?vue&type=script&lang=js"
export * from "./ModalEliminarDocumento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ade0751",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ade0751')) {
      api.createRecord('4ade0751', component.options)
    } else {
      api.reload('4ade0751', component.options)
    }
    module.hot.accept("./ModalEliminarDocumento.vue?vue&type=template&id=4ade0751&scoped=true", function () {
      api.rerender('4ade0751', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/documento/ModalEliminarDocumento.vue"
export default component.exports